import { render, staticRenderFns } from "./buttonCore.vue?vue&type=template&id=1b8f5ffa&scoped=true&"
import script from "./buttonCore.vue?vue&type=script&lang=js&"
export * from "./buttonCore.vue?vue&type=script&lang=js&"
import style0 from "./buttonCore.vue?vue&type=style&index=0&id=1b8f5ffa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f5ffa",
  null
  
)

export default component.exports